// extracted by mini-css-extract-plugin
export default {"snackbarContainer":"CustomSnackbar_snackbarContainer__GyKm1","snackbarText":"CustomSnackbar_snackbarText__kXMYH"};